import { createNamedContext } from '@utils';
import { PricingContextValue, PricingModalContextValue, PricingModalPlanContextValue } from './interfaces';

export const PricingContext = createNamedContext<PricingContextValue | undefined>(undefined, 'Pricing.Context');
export const PricingModalContext = createNamedContext<PricingModalContextValue | undefined>(undefined, 'Pricing.Modal.Context');
export const PricingModalPlanContext = createNamedContext<PricingModalPlanContextValue | undefined>(undefined, 'Pricing.Modal.Plan.Context');